import React from "react";
import "./ServiceTestimonial.css";

import volunteer1 from "../../assets/images/ArvindMills.jpeg";
import volunteer2 from "../../assets/images/barsys.avif";
import volunteer3 from "../../assets/images/Jarsh.jpg";
import volunteer4 from "../../assets/images/justDial.webp";
import volunteer5 from "../../assets/images/MedversityChauwklogo.webp";
import volunteer6 from "../../assets/images/RelainceRetailChauwklogo.webp";
import volunteer7 from "../../assets/images/gmrLogo.png";
import volunteer8 from "../../assets/images/ridhira.png";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Carousel = () => {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    appendDots: (dots) => (
      <div style={{ marginTop: "-40px" }}>
        <ul> {dots} </ul>
      </div>
    ),
  };

  const data = [
    { name: "Arvind", img: volunteer1 },
    { name: "Medversity", img: volunteer5 },
    { name: "Barsyl", img: volunteer2 },
    { name: "Jarsh", img: volunteer3 },
    { name: "Reliance", img: volunteer6 },
    { name: "Just Dial", img: volunteer4 },
    { name: "GMR", img: volunteer7 },
    { name: "Ridhira", img: volunteer8 },
  ];

  return (
    <div className="carousel-container">
      <Slider {...settings}>
        {data.map((d, index) => (
          <div key={index} className="carousel-card">
            <div className="carousel-image-container">
              <img src={d.img} alt={d.name} className="carousel-image" />
            </div>
            <div className="carousel-content">
              <p className="carousel-title">{d.name}</p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Carousel;
